module.exports = __webpack_public_path__ + "assets/img/box6_img2.6ec2d6e0.png";